import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VSelect, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetTypeSelect.label'),
      "items": _vm.widgetTypeOptions,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "value": _vm.value
    },
    on: {
      "input": val => _vm.$emit('input', val)
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };